import apiClient from '../../../shared/api/apiClient';
import type {
  AdminDemoLeadConversionInput,
  AdminDemoLeadConversionJobStatus,
  AdminDemoLeadConversionResult,
  AdminDemoLeadDetail,
  AdminDemoLeadListQuery,
  AdminDemoLeadPage,
  AdminDemoLeadStatusRequest,
} from '../legalTypes';

export const demoLeadsApi = {
  list: async (
    query: AdminDemoLeadListQuery,
    signal?: AbortSignal
  ): Promise<AdminDemoLeadPage> => {
    const config = { params: query, signal } as Parameters<typeof apiClient.get>[1];
    const response = await apiClient.get<AdminDemoLeadPage>(
      '/super-admin/demo-requests',
      config
    );
    return response.data;
  },

  get: async (leadId: number): Promise<AdminDemoLeadDetail> => {
    const response = await apiClient.get<AdminDemoLeadDetail>(
      `/super-admin/demo-requests/${leadId}`
    );
    return response.data;
  },

  updateStatus: async (
    leadId: number,
    request: AdminDemoLeadStatusRequest
  ): Promise<AdminDemoLeadDetail> => {
    const response = await apiClient.post<AdminDemoLeadDetail>(
      `/super-admin/demo-requests/${leadId}/status`,
      request
    );
    return response.data;
  },

  convert: async (
    leadId: number,
    request: AdminDemoLeadConversionInput,
    idempotencyKey: string
  ): Promise<AdminDemoLeadConversionResult> => {
    const response = await apiClient.post<AdminDemoLeadConversionResult>(
      `/super-admin/demo-requests/${leadId}/convert`,
      { ...request, idempotencyKey },
      { headers: { 'Idempotency-Key': idempotencyKey } }
    );
    return response.data;
  },

  getConversionJob: async (
    leadId: number
  ): Promise<AdminDemoLeadConversionJobStatus | null> => {
    const response = await apiClient.get<AdminDemoLeadConversionJobStatus | null>(
      `/super-admin/demo-requests/${leadId}/conversion-job`
    );
    return response.data;
  },
};
